import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Curriclum } from '../../../models/ilanding';

@Component({
  selector: 'app-level-item',
  imports: [
    RouterLink
  ],
  templateUrl: './level-item.component.html',
  styleUrl: './level-item.component.css'
})
export class LevelItemComponent {
  level = input<Curriclum>();

}
